import axios from '../../helpers/axios-setup';

export const getCapabilities = () => axios.get(`/certifications/capabilities/all`);
